import { render, staticRenderFns } from "./AgentCommissionList.vue?vue&type=template&id=57824b5e&scoped=true"
import script from "./AgentCommissionList.vue?vue&type=script&lang=js"
export * from "./AgentCommissionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57824b5e",
  null
  
)

export default component.exports